var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#FFF",
    strokeWidth: 1.7,
    cx: 8,
    cy: 8,
    r: 7.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.902 5.708a.897.897 0 00.902-.891.901.901 0 10-.902.891zM8.639 12V6.588H7.176V12h1.463z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
}
export default SvgInfo;